import { FC, ReactNode, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { BACK_NAVIGATION_RULES, IBackNavigationRule } from "common/shared/constants/backNavigationRules";

interface IBackNavigationProviderProps {
  children: ReactNode;
}

const matchPattern = (pathname: string, pattern: string): boolean => {
  const patternParts = pattern.split("/");
  const pathParts = pathname.split("/");

  if (patternParts.length !== pathParts.length) {
    return false;
  }

  return patternParts.every((part, index) => {
    if (part === "*") return true;
    return part === pathParts[ index ];
  });
};

const findMatchingRule = (pathname: string, rules: IBackNavigationRule[]): IBackNavigationRule | null => {
  for (let i = rules.length - 1; i >= 0; i--) {
    const rule = rules[ i ];
    if (matchPattern(pathname, rule.pattern)) {
      return rule;
    }
  }
  return null;
};

export const BackNavigationProvider: FC<IBackNavigationProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedRule = findMatchingRule(currentPath, BACK_NAVIGATION_RULES);

    if (!matchedRule) {
      return;
    }

    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      navigate(matchedRule.destination, { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [ location.pathname, navigate ]);

  return <>{ children }</>;
};

